import { get } from './client';
import { ROUTES } from './config';
import type { ApiEnvelope, Repairer } from '@/types/types';

export const repairersApi = {
    list: () => get<ApiEnvelope<Repairer[]>>(ROUTES.COMPANY_CONNECTIONS),
};
